import { render, staticRenderFns } from "./CoursesListPage.vue?vue&type=template&id=335dec6e&scoped=true"
import script from "./CoursesListPage.vue?vue&type=script&lang=ts"
export * from "./CoursesListPage.vue?vue&type=script&lang=ts"
import style0 from "./CoursesListPage.vue?vue&type=style&index=0&id=335dec6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335dec6e",
  null
  
)

export default component.exports